var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthereumEthLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1563_5360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99844 0L9.86426 0.455773V13.6801L9.99844 13.8139L16.1369 10.1855L9.99844 0Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85991 10.1853L9.99759 0.00140782V7.39524V13.8133L3.85991 10.1853Z",
    fill: "#8C8C8C",
    stroke: "#2E260A",
    strokeWidth: 0.000782846
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99825 14.9765L16.1388 11.3509L9.99811 19.9991L9.92275 19.7791V15.0686L9.99825 14.9765Z",
    fill: "#3C3C3B",
    stroke: "#2E260A",
    strokeWidth: 0.000782846
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99799 19.9999V14.9762L3.85938 11.3496L9.99799 19.9999Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99805 13.8137L16.1365 10.1852L9.99805 7.39502V13.8137Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85938 10.1852L9.99799 13.8137V7.39502L3.85938 10.1852Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1563_5360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumEthLogo);
export default __webpack_public_path__ + "static/media/ethereum-eth-logo.f125ab202a70630174cb7fee70585e08.svg";
export { ForwardRef as ReactComponent };